import React,  { useRef } from "react";
import styled from "styled-components";

export const Container = styled.div`
    display: block;
    max-width: 816px;
    margin: auto;
    margin: ${props => props.theme.spacing};
    iframe {
        width: 100%;
        height: 100%;
        min-height: 461px;
    }
    @media (max-width: 767px){
        margin: 0 18px;
        iframe {
            min-height: 190px;
        }
    }
`;


export const SubTitle = styled.h4`
    color: #050505;
    font-family: Mallory;
    font-size: 18px;
    font-weight: 900;
    letter-spacing: 1px;
    line-height: 22px;
    @media(max-width: 767px){
        margin: 12px 0;
    }
`;

export const Paragrph = styled.p`
    color: #212323;
    font-family: Mallory;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 32px;
`;

export const VideoURL = styled.video`
    height: 461px;
    width: 816px;
    position:relative;
    z-index:0;
    @media (max-width: 767px){
        width: 100%;
        height: auto;
    }
`;

export const Overlay = styled.h4`
    color: #FFFFFF;
    font-family: Mallory-Book;
    font-size: 32px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    top: 135px;
    z-index: 1;
    @media (max-width: 767px){
        position: absolute;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        text-align: center;
        top: 45px;
    }
    @media (min-width: 768px) and (max-width: 992px){
        position: absolute;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        text-align: center;
    }
`;

export const VideoContainer = styled.div`
    position: relative;
`;

export const Button = styled.button`
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    font-family: Mallory;
    font-weight: 500;
    z-index: 1;
    box-sizing: border-box;
    height: 40px;
    width: 176px;
    border: 1px solid #FFFFFF;
    background: none;
    color: #FFFFFF;
    top: 220px;
    @media (max-width: 767px){
        position: absolute;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        text-align: center;
        top: 112px;
    }
`;

export const BlackOverlay = styled.div`
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    background: black;
    opacity: 0.5;
`;